import {
    DEFAULT_PAYLOAD,
    booleanTypes,
    taskStatusTypes,
    ticketStatusTypes,
    validateTypes,
} from './ticketlist.constants';
import { formatDate } from '../../../../utils/dates/date.utils';
import { DATE_FORMATS } from '../../../../constants/common/dateTimeValues';
import { configs } from '../../../../constants/configs/configs';
import { IFilterOptions } from './ticketlist.interface';
import { Dispatch } from 'redux';

export const statusChanged = (
    ticket: any,
    isArchivedAllowed: boolean,
    isAssignAllowed: boolean,
    isSimplifiedView: boolean,
) => {
    const updatedTicket = { ...ticket };

    updatedTicket.allowView = true;
    updatedTicket.allowEdit = false;
    updatedTicket.allowCancel = false;
    updatedTicket.allowMarkAsComplete = false;
    updatedTicket.allowClaim = false;
    updatedTicket.allowReassign = false;
    updatedTicket.allowAssign = false;
    updatedTicket.allowReopen = false;
    updatedTicket.allowRestart = false;
    updatedTicket.allowArchive = false;

    updatedTicket.isCheckboxDisabled =
        updatedTicket.status == ticketStatusTypes.RESOLVED || updatedTicket.status == ticketStatusTypes.CANCELED;

    if (!isSimplifiedView) {
        if (
            updatedTicket.status === ticketStatusTypes.COMPLETED ||
            updatedTicket.status === ticketStatusTypes.CANCELED ||
            updatedTicket.status === ticketStatusTypes.RESOLVED
        ) {
            updatedTicket.allowEdit = false;
            updatedTicket.allowCancel = false;
            updatedTicket.allowAssign = false;
        } else {
            updatedTicket.allowEdit = true;
            updatedTicket.allowCancel = true;
            if (updatedTicket.taskStatus === taskStatusTypes.CLAIMED) {
                updatedTicket.allowReassign = true;
            } else if (updatedTicket.taskStatus === taskStatusTypes.UNCLAIMED) {
                updatedTicket.allowAssign = true;
            }
        }
    }

    if (
        updatedTicket.status !== ticketStatusTypes.COMPLETED &&
        updatedTicket.status !== ticketStatusTypes.RESOLVED &&
        updatedTicket.taskStatus !== taskStatusTypes.CANCELED
    ) {
        if (updatedTicket.taskStatus === taskStatusTypes.CLAIMED) {
            updatedTicket.allowMarkAsComplete = true;
        }
        if (updatedTicket.taskStatus === taskStatusTypes.UNCLAIMED) {
            updatedTicket.allowClaim = true;
        }
        if (updatedTicket.taskStatus === taskStatusTypes.OPEN) {
            updatedTicket.allowMarkAsComplete = true;
            updatedTicket.allowReassign = true;
        }
        if (
            updatedTicket.taskStatus === taskStatusTypes.REOPENED ||
            updatedTicket.taskStatus === taskStatusTypes.RESTARTED
        ) {
            updatedTicket.allowClaim = true;
            updatedTicket.allowAssign = true;
        }
    }

    if (updatedTicket.status === ticketStatusTypes.CANCELED || updatedTicket.status === ticketStatusTypes.RESOLVED) {
        if (updatedTicket.archiveFlag === 'Y') {
            updatedTicket.allowReopen = false;
            updatedTicket.allowRestart = false;
        } else {
            updatedTicket.allowReopen = true;
            updatedTicket.allowRestart = true;
        }
        if (updatedTicket.workflowpermission !== 'TKM_WORKFLOW_VERIFY') {
            updatedTicket.allowReopen = true;
        }
    }

    if (isArchivedAllowed) {
        if (
            (updatedTicket.status !== ticketStatusTypes.COMPLETED &&
                updatedTicket.status !== ticketStatusTypes.RESOLVED &&
                updatedTicket.taskStatus !== taskStatusTypes.CANCELED) ||
            updatedTicket.archiveFlag === validateTypes.Y
        ) {
            updatedTicket.allowArchive = false;
        } else {
            updatedTicket.allowArchive = true;
        }
    } else {
        updatedTicket.allowArchive = false;
    }

    if (updatedTicket.allowAssign && !isAssignAllowed) {
        updatedTicket.allowAssign = false;
    }
    if (updatedTicket.status === ticketStatusTypes.CANCELED) {
        updatedTicket.allowClaim = false;
    }

    return updatedTicket;
};
export const processTicketData = (tickets: any, ticketController: any) => {
    const { isSimplifiedView, isArchivedAllowed, isAssignAllowed, pageSize } = ticketController;

    const updatedTickets = tickets?.map(ticket => {
        return statusChanged(ticket, isArchivedAllowed, isAssignAllowed, isSimplifiedView);
    });

    return updatedTickets;
};

export const handleChange = (name: string, value: string | string[] | number | number[], setValue) => {
    setValue(name, value, {
        shouldValidate: true,
        shouldDirty: true,
    });
};

export const handleFieldChange = (name: string, value: string | string[] | number | number[], setValue) => {
    handleChange(name, value, setValue);
};

export const getTicketsSessionData = () => {
    const searchCriteria = sessionStorage.getItem('ticketListSearchVarsV1');
    const parsedSearchCriteria = searchCriteria ? JSON.parse(searchCriteria) : {};
    return parsedSearchCriteria;
};

export const setTicketsSessionData = (data: any) => {
    const searchCriteria = getTicketsSessionData();
    const ticketData = {
        ticketSubject: data.ticketSubject || '',
        ticketComments: data.ticketComments || '',
        requestedByName: data.requestedByName || '',
        requestedBy: data.requestedBy || '',
        ticketQueues: data.ticketQueues.join(',') || '',
        ticketPriority: data.ticketPriority.join(',') || '',
        assignee: data.assignee || '',
        assigneeId: data.assigneeId || '',
        requestedBytagId: data.requestedBytagId || '',
        ticketNumber: data.ticketNumber || '',
        submittedBefore:
            new Date(data.submittedBefore).toString() !== 'Invalid Date'
                ? formatDate(data.submittedBefore, DATE_FORMATS.MM_DD_YYYY)
                : '',
        submittedAfter:
            new Date(data.submittedAfter).toString() !== 'Invalid Date'
                ? formatDate(data.submittedAfter, DATE_FORMATS.MM_DD_YYYY)
                : '',
        ticketStatus: data.ticketStatus.join(',') || '',
        assignedToMe: false,
        unClaimedTicket: false,
        requester: data.requester || '',
        roleId: data.roleId || '',
        archiveFlagValue: false,
        customFieldSelect: data.customFieldSelect || -1,
        customFieldSelectVal: data.customFieldSelectVal || '',
        ticketCategorySelect: data.ticketCategorySelect || -1,
        ticketType: data.ticketType.join(',') || '',
    };

    sessionStorage.setItem(
        'ticketListSearchVarsV1',
        JSON.stringify({ ...searchCriteria, ...ticketData, createdForRole: data.createdForRole }),
    );
    return ticketData;
};

export const createTicketPayload = (pageSortInfo: any, simpleSearchCriteria?: any, isFilteredCall: boolean = false) => {
    const userFilter =
        simpleSearchCriteria?.createdByMeFilter ||
        simpleSearchCriteria?.assignedToMeFilter ||
        simpleSearchCriteria?.assignedToMeFilter;
    const searchCriteria = getTicketsSessionData();

    let payload = { ...DEFAULT_PAYLOAD };
    if (isFilteredCall) {
        payload = {
            ...payload,
            filterticketStatus: simpleSearchCriteria?.ticketStatus || '',
            userticketQueues: simpleSearchCriteria?.ticketQueues || '',
            userFilter: userFilter || '',
        };
    } else {
        payload = {
            ...payload,
            ticketSubject: searchCriteria.ticketSubject || '',
            ticketComments: searchCriteria.ticketComments || '',
            requestedByName: searchCriteria.requestedByName || '',
            requestedBy: searchCriteria.requestedBy || '',
            ticketQueues: searchCriteria.ticketQueues || '',
            ticketPriority: searchCriteria.ticketPriority || '',
            assignee: searchCriteria.assignee || '',
            assigneeId: searchCriteria.assigneeId || '',
            requestedBytagId: searchCriteria.requestedBytagId || '',
            ticketNumber: searchCriteria.ticketNumber || '',
            submittedBefore: searchCriteria.submittedBefore || '',
            submittedAfter: searchCriteria.submittedAfter || '',
            ticketStatus: searchCriteria.ticketStatus || '',
            assignedToMe: false,
            unClaimedTicket: false,
            requester: searchCriteria.requester || '',
            archiveFlagValue: false,
            customFieldSelect: searchCriteria.customFieldSelect || -1,
            customFieldSelectVal: searchCriteria.customFieldSelectVal || '',
            ticketCategorySelect: searchCriteria.ticketCategorySelect || -1,
            ticketType: searchCriteria.ticketType || '',
        };
    }
    return {
        ...payload,
        pageNumber: pageSortInfo.currentPage,
        sortBy: pageSortInfo.sortField,
        sortOrder: pageSortInfo.sortOrder,
        csrftoken: window.csrf_token,
    };
};

export const parseQueryString = () => {
    const getQuery = window.location.search;
    const queryString = String(getQuery).replace(/\?/gi, '');

    const queryArray = queryString.split('&');

    const retObj: Record<string, string | undefined> = {
        period: undefined,
        ticketPriority: undefined,
    };

    queryArray.forEach(obj => {
        const valSplit = String(obj).split('=');
        if (valSplit[0]) {
            retObj[valSplit[0]] = decodeURIComponent(valSplit[1] || '');
        }
    });

    if (retObj.ticketPriority !== undefined) {
        retObj.ticketPriority = String(retObj.ticketPriority).replace('[', '').replace(']', '');
    }

    if (retObj.fromAgeingReports === booleanTypes.TRUE) {
        retObj.ticketStatus = `${ticketStatusTypes.OPEN},${ticketStatusTypes.UNCLAIMED}`;
    }
    if (retObj.fromPendingReport === booleanTypes.TRUE) {
        retObj.ticketStatus = ticketStatusTypes.OPEN;
    }

    return retObj;
};

export const getPath = (fileName: string) => {
    return configs.ENV.DEVELOPMENT
        ? `../../../../assets/images/${fileName}`
        : configs.endpoints.IMAGES.processReplacements({
            relativePath: '/resources/images',
            fileName,
        });
};

export const getViewDetailUrl = (ticketId: string) => {
    const url = new URL(
        configs.endpoints.TICKET_MGMT_TICKET_DETAIL.processReplacements({ encTicketId: ticketId }),
        window.location.origin,
    );
    return url.toString();
};

export const highlightFields = (data: any): IFilterOptions => {
    return Object.fromEntries(
        Object.entries(data).map(([fieldName, fieldValue]) => {
            if (Array.isArray(fieldValue)) {
                return [fieldName, fieldValue.length > 0];
            }
            const isValid = fieldValue !== null && fieldValue !== undefined && fieldValue !== '' && fieldValue !== -1;
            return [fieldName, isValid];
        }),
    ) as IFilterOptions;
};

export const updateTicketList = (
    dispatch: Dispatch<any>,
    ticketList: any[],
    key: string,
    value: any,
    updatedData: { taskStatus: string; status: string },
) => {
    const index = ticketList.findIndex(ticket => ticket[key] === value);
    if (index !== -1) {
        const updatedTickets = [...ticketList];
        updatedTickets[index] = {
            ...updatedTickets[index],
            ...updatedData,
        };
        dispatch({ type: 'UPDATE_TICKETS', payload: updatedTickets });
    }
};